import { render, staticRenderFns } from "./SetupCompletedModal.vue?vue&type=template&id=3c196c3d&"
import script from "./SetupCompletedModal.vue?vue&type=script&lang=js&"
export * from "./SetupCompletedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports